var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"cover"},[_c('img',{staticClass:"responsive card-img-top",attrs:{"src":_vm.classRoomPhoto,"alt":"content-img"}})])}
var staticRenderFns = []

export { render, staticRenderFns }